import EmailContactForm from "../../components/EmailSend.js";

import DATA from "../data/_entity.json";
import socialIcons from "../../assets/icons/socialIcons.js";

const Contact = () => {

   const styleH4 = {
      color: "var(--main-font-color)",
      fontSize: "calc(0.4rem + var(--fit-font))",
      fontFamily: "var(--general-font-family)"
   };


   return (
      <>

         <h2>&nbsp;Contact Us</h2>
         <div className="framer">

            <h3>Like to know more?</h3>

            <div style={{
               display: "flex",
               flexDirection: "column",
               alignItems: "center"
            }}>

               <h4 style={styleH4}>Please do give us a call:</h4>
               <div style={{ fontSize: "calc(0.8rem + 2vw)", marginBottom: "20px" }}>
                  &nbsp;📞&nbsp;<a href={`Tel:${DATA.entity.contact.Telephone}`}>{DATA.entity.contact.Telephone}</a>
               </div>

               <div style={{ border: "1px dotted #11223344", borderRadius: "15px", padding: "20px" }}>
                  <h4 style={styleH4}>Send us a short message and we'll get back to you:</h4>

                  <EmailContactForm >
                     {/* <div style={{ display: "flex", margin: 10, flexDirection: "column", alignItems: "center" }}>
                        <label>Name:&nbsp;&nbsp;&nbsp;&nbsp;<input id="name" placeholder="Please type your Name" required></input></label>
                        <label>Email:&nbsp;&nbsp;&nbsp;&nbsp;<input id="email" placeholder="Your Email" type="email" required></input></label>
                        <label>Message:&nbsp;<textarea id="message" name="message" rows="4" cols="21" placeholder="Type your message here" required></textarea></label>
                        <hr />
                     </div> */}
                  </EmailContactForm>
               </div>

               <h4 style={styleH4}>Our Email address:</h4>
               <div style={{ fontSize: "calc(0.8rem + 2vw)", marginBottom: "20px" }}>
                  &nbsp;<a href={`mailto:${DATA.entity.contact.Email}`}>{DATA.entity.contact.Email}</a>
               </div>

               <h4 style={styleH4}>Also find us at: </h4>
               <div style={{ display: "inline-flex" }} >
                  {(Object.keys(DATA.entity.contact.Social).length !== 0) ? (
                     Object.entries(DATA.entity.contact.Social).map((key) => {
                        let source = socialIcons[`${key[0]}`];
                        return (
                           <li key={key[0]} className="button" title={source.title}>
                              <a href={key[1]}
                                 target="_blank"
                                 rel="noreferrer"
                                 className="social-icons"
                              >
                                 {source}
                              </a>
                           </li>
                        )
                     })
                  ) : null}
               </div >

            </div>

         </div >

      </>
   )
}

export default Contact;
